import { YardTaskCheckEntity, type CheckTaskViewData, type Maybe } from '@nova/core';

/**
 * Check tasks are discriminated by `relatedEntity` — the free-form `category`
 * column is a display label only and MUST NOT be used to branch behavior. Use
 * these predicates wherever Circe code needs the task type.
 *
 * - AssetContainer → check on a single container
 * - Spot           → check on a single spot
 * - SpotArea       → check on a single area
 * - Warehouse      → warehouse-scoped inventory check (the "open inventory" flow)
 */
type CheckTaskLike = Pick<CheckTaskViewData, 'relatedEntity'> | null | undefined;

function matchesEntity(task: CheckTaskLike, entity: YardTaskCheckEntity): boolean {
  const value: Maybe<YardTaskCheckEntity> = task?.relatedEntity;
  return value === entity;
}

export function isAssetCheckTask(task: CheckTaskLike): boolean {
  return matchesEntity(task, YardTaskCheckEntity.AssetContainer);
}

export function isSpotCheckTask(task: CheckTaskLike): boolean {
  return matchesEntity(task, YardTaskCheckEntity.Spot);
}

export function isSpotAreaCheckTask(task: CheckTaskLike): boolean {
  return matchesEntity(task, YardTaskCheckEntity.SpotArea);
}

export function isInventoryCheckTask(task: CheckTaskLike): boolean {
  return matchesEntity(task, YardTaskCheckEntity.Warehouse);
}
